import { ExtraResponse } from "@/models/api/ExtraResponse";
import { Extra } from "@/models/www/Extra";
import baseApi from "./api.service";

const extrasService = {
	async getExtras(): Promise<Extra[]> {
		return new Promise((resolve, reject) => { 
			baseApi.get<ExtraResponse[]>("extras/available")
			.then(resp => resolve(resp.map(e => new Extra(e))))
			.catch(err => reject(err));
		});
	}
}

export default extrasService;